// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"iI","message":"iJ","close":"iK","closeMessage":"iL","closeIcon":"iM"};